import React from 'react';
import Select from 'react-select';
import { getTranslation } from '../../../utils/translation';

const Categories = props => {
    const { categories, selectedCategoryId } = props;

    const options = categories.map(category => ({
        value: category.id,
        label: category.name,
        selected: category.id === selectedCategoryId,
    }));

    const selectedOption = options.find(option => option.selected);

    const onChange = value => {
        if (value.value === selectedOption.value) return;

        if (props.onChange) {
            props.onChange(value);
        }
    };

    return (
        <Select
            className='common-select common-select--events'
            classNamePrefix='common'
            menuPlacement={'auto'}
            value={selectedOption}
            onChange={onChange}
            options={options}
            noOptionsMessage={getTranslation('noOptionsMessage')}
        />
    );
};

export default Categories;
